import { render } from "./PaymentTransaction.vue?vue&type=template&id=c64bccc6&scoped=true"
import script from "./PaymentTransaction.vue?vue&type=script&lang=js"
export * from "./PaymentTransaction.vue?vue&type=script&lang=js"

import "./PaymentTransaction.vue?vue&type=style&index=0&id=c64bccc6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c64bccc6"]])

export default __exports__